////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep, find, isEmpty, reject, findIndex, map, filter, includes, isUndefined } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'
import { uriList } from '../../routings/settings/RouteList'

extendUpdate(update)

const tagsManager = {
	[ActionsTypes.GET_TAGS]: (state) =>
		update(state, {
			tagsManager: {
				isLoading: {
					$set: true,
				},
				tagDetail: {
					users: {
						$set: false,
					},
					kiosks: {
						$set: false,
					},
				},
				items: [],
			},
		}),
	[ActionsTypes.GET_TAGS_SUCCESS]: (state, payload) => {
		return update(state, {
			tagsManager: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: payload.tags.tags,
				},
			},
		})
	},
	[ActionsTypes.GET_TAGS_FAILURE]: (state, payload) =>
		update(state, {
			tagsManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.CREATE_TAG]: (state) =>
		update(state, {
			tagsManager: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.CREATE_TAG_SUCCESS]: (state, payload) => {
		let tagsList = cloneDeep(state.tagsManager.items)
		tagsList.push(payload.tag)

		return update(state, {
			tagsManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
				items: {
					$set: tagsList,
				},
				tagDetail: {
					users: {
						$set: false,
					},
					kiosks: {
						$set: false,
					},
				},
			},
		})
	},
	[ActionsTypes.CREATE_TAG_FAILURE]: (state, payload) => {
		return update(state, {
			tagsManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.GET_TAG_DETAIL]: (state) =>
		update(state, {
			tagsManager: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				tagDetail: {
					users: {
						$set: false,
					},
					kiosks: {
						$set: false,
					},
				},
			},
		}),
	[ActionsTypes.GET_TAG_DETAIL_SUCCESS]: (state, payload) => {
		let objUsers = false
		let objKiosks = false
		if (payload.typeList === 'user') {
			// If we get there by user detail,
			// we want to filter by current edited user
			objUsers = payload.list
			if (!isEmpty(state.userDetail.items)) {
				objUsers.usersWithoutTags = filter(objUsers.usersWithoutTags, { id: state.userDetail.items.id })
				objUsers.usersWithTags = filter(objUsers.usersWithTags, { id: state.userDetail.items.id })
			}
		} else {
			objKiosks = payload.list
		}

		return update(state, {
			tagsManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
				tagDetail: {
					users: {
						$set: objUsers,
					},
					kiosks: {
						$set: objKiosks,
					},
				},
			},
		})
	},
	[ActionsTypes.GET_TAG_DETAIL_FAILURE]: (state, payload) =>
		update(state, {
			tagsManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.RESET_TAG]: (state) => {
		return update(state, {
			tagsManager: {
				tagDetail: {
					users: {
						$set: false,
					},
					kiosks: {
						$set: false,
					},
				},
				items: {
					$set: [],
				},
			},
		})
	},
	[ActionsTypes.RESET_TAG_DETAIL]: (state) => {
		return update(state, {
			tagsManager: {
				tagDetail: {
					users: {
						$set: false,
					},
					kiosks: {
						$set: false,
					},
				},
			},
		})
	},
	[ActionsTypes.DELETE_TAG]: (state) =>
		update(state, {
			tagsManager: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.DELETE_TAG_SUCCESS]: (state, payload) => {
		let oldTags = cloneDeep(state.tagsManager.items)
		const idTag = payload.idTag
		oldTags = reject(oldTags, { id: idTag })

		return update(state, {
			tagsManager: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: [...oldTags],
				},
				error: {
					$set: false,
				},
				deleteSuccess: {
					$set: true,
				},
				tagDetail: {
					users: {
						$set: false,
					},
					kiosks: {
						$set: false,
					},
				},
			},
		})
	},
	[ActionsTypes.DELETE_TAG_FAILURE]: (state, payload) => {
		return update(state, {
			tagsManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.UPDATE_TAG_HEADER]: (state) =>
		update(state, {
			tagsManager: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.UPDATE_TAG_HEADER_SUCCESS]: (state, payload) => {
		let tag = cloneDeep(payload.tag)
		let tagsList = cloneDeep(state.tagsManager.items)
		const ind = findIndex(tagsList, { id: tag.id })

		tagsList.splice(ind, 1, tag)

		return update(state, {
			tagsManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
				items: {
					$set: tagsList,
				},
			},
		})
	},
	[ActionsTypes.UPDATE_TAG_HEADER_FAILURE]: (state, payload) => {
		return update(state, {
			rolesManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.UPDATE_TAG_CONTENT]: (state) =>
		update(state, {
			tagsManager: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.UPDATE_TAG_CONTENT_SUCCESS]: (state, payload) => {
		// We refresh everything
		let tagsList = cloneDeep(state.tagsManager.items)
		let tagsUsersList = cloneDeep(state.tagsManager.tagDetail.users)
		let tagsKiosksList = cloneDeep(state.tagsManager.tagDetail.kiosks)
		if (!isUndefined(payload.tags.availableTags)) {
			tagsList = payload.tags.availableTags.tags
		}
		if (!isUndefined(payload.tags.availableUsers)) {
			tagsUsersList = payload.tags.availableUsers
		}
		if (!isUndefined(payload.tags.availableKiosks)) {
			tagsKiosksList = payload.tags.availableKiosks
		}

		// If we are in user detail and that we add / delete our edited user,
		// we also need to update user detail...

		let userDetail = cloneDeep(state.userDetail.items)

		if (includes(window.location.pathname, `${uriList.usersManagerEdit}`)) {
			// Check if detailed user is found, and if added or deleted tag
			map(payload.sentData.usersTagToUpdate, (elem) => {
				if (elem.idUser === userDetail.id) {
					if (elem.toLinked) {
						// For each tag, check if private/public
						// To know where we add it
						map(elem.idTags, (elem) => {
							const f = filter(tagsList, ['id', elem])
							// Also need to check if tag is already here !
							const foundPrivateTag = find(userDetail.privateTags.tags, (o) => o.id === f[0].id) ? true : false
							const foundPublicTag = find(userDetail.publicTags.tags, (o) => o.id === f[0].id) ? true : false

							if (f[0].isPrivate && !foundPrivateTag) {
								userDetail.privateTags.tags.push(f[0])
							} else if (!f[0].isPrivate && !foundPublicTag) {
								userDetail.publicTags.tags.push(f[0])
							}
						})
					} else {
						// Iterate each list and remove tags
						map(elem.idTags, (elem) => {
							const f = filter(tagsList, ['id', elem])

							if (f[0].isPrivate) {
								userDetail.privateTags.tags = reject(userDetail.privateTags.tags, (o) => o.id === f[0].id)
							} else {
								userDetail.publicTags.tags = reject(userDetail.privateTags.tags, (o) => o.id === f[0].id)
							}
						})
					}
				}
			})
		}

		return update(state, {
			tagsManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
				items: {
					$set: tagsList,
				},
				tagDetail: {
					users: {
						$set: tagsUsersList,
					},
					kiosks: {
						$set: tagsKiosksList,
					},
				},
			},
			userDetail: {
				items: {
					$set: userDetail,
				},
			},
		})
	},
	[ActionsTypes.UPDATE_TAG_CONTENT_FAILURE]: (state, payload) => {
		return update(state, {
			tagsManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
}

export default tagsManager
